import { documentBundleActions } from './constant';

const {
  REQUEST_GET_PAYER_FILTERS,
  RESET_GET_PAYER_FILTERS,
  REQUEST_GET_PATIENT_FILTERS,
  RESET_GET_PATIENT_FILTERS,
  REQUEST_GET_DOCUMENT_SUMMARY,
  RESET_GET_DOCUMENT_SUMMARY,
  REQUEST_GET_DOWNLOAD_JOBS,
  RESET_GET_DOWNLOAD_JOBS,
  REQUEST_SUBMIT_DOWNLOAD_JOB,
  RESET_SUBMIT_DOWNLOAD_JOB,
  REQUEST_GET_PRESIGNED_URL,
  RESET_GET_PRESIGNED_URL,
  REQUEST_GET_THERAPIST_FILTERS,
  RESET_GET_THERAPIST_FILTERS,
  REQUEST_SEARCH_PATIENTS,
  RESET_SEARCH_PATIENTS,
  REQUEST_GET_PATIENT_INTERVALS,
  RESET_GET_PATIENT_INTERVALS,
  REQUEST_GET_PATIENT_DOCUMENTS,
  RESET_GET_PATIENT_DOCUMENTS,
  CANCEL_DOWNLOAD_JOB,
  ADD_DOWNLOAD_JOB,
} = documentBundleActions;

export const getPayerFiltersAction = (payload: Record<string, string>) => ({
  type: REQUEST_GET_PAYER_FILTERS,
  payload,
});
export const resetPayerFiltersAction = () => ({ type: RESET_GET_PAYER_FILTERS });

export const getPatientFiltersAction = (payload: Record<string, string | string[]>) => ({
  type: REQUEST_GET_PATIENT_FILTERS,
  payload,
});
export const resetPatientFiltersAction = () => ({ type: RESET_GET_PATIENT_FILTERS });

export const getDocumentSummaryAction = (payload: Record<string, string | string[]>) => ({
  type: REQUEST_GET_DOCUMENT_SUMMARY,
  payload,
});
export const resetDocumentSummaryAction = () => ({ type: RESET_GET_DOCUMENT_SUMMARY });

export const getDownloadJobsAction = () => ({ type: REQUEST_GET_DOWNLOAD_JOBS });
export const resetDownloadJobsAction = () => ({ type: RESET_GET_DOWNLOAD_JOBS });

export const submitDownloadJobAction = (payload: object) => ({
  type: REQUEST_SUBMIT_DOWNLOAD_JOB,
  payload,
});
export const resetSubmitDownloadJobAction = () => ({ type: RESET_SUBMIT_DOWNLOAD_JOB });

export const getPresignedUrlAction = (jobId: string) => ({
  type: REQUEST_GET_PRESIGNED_URL,
  jobId,
});
export const resetPresignedUrlAction = () => ({ type: RESET_GET_PRESIGNED_URL });

export const cancelDownloadJobAction = (jobId: string) => ({
  type: CANCEL_DOWNLOAD_JOB,
  jobId,
});

export const addDownloadJobAction = (job: object) => ({
  type: ADD_DOWNLOAD_JOB,
  job,
});

// ── Patient-first workflow (SQ-160, SQ-161, SQ-162) ──

export const searchPatientsAction = (payload: Record<string, string | number>) => ({
  type: REQUEST_SEARCH_PATIENTS,
  payload,
});
export const resetSearchPatientsAction = () => ({ type: RESET_SEARCH_PATIENTS });

export const getPatientIntervalsAction = (patientUuid: string) => ({
  type: REQUEST_GET_PATIENT_INTERVALS,
  patientUuid,
});
export const resetPatientIntervalsAction = () => ({ type: RESET_GET_PATIENT_INTERVALS });

export const getPatientDocumentsAction = (
  patientUuid: string,
  params: Record<string, string | string[]>
) => ({
  type: REQUEST_GET_PATIENT_DOCUMENTS,
  patientUuid,
  params,
});
export const resetPatientDocumentsAction = () => ({ type: RESET_GET_PATIENT_DOCUMENTS });

export const getTherapistFiltersAction = (payload: Record<string, string>) => ({
  type: REQUEST_GET_THERAPIST_FILTERS,
  payload,
});
export const resetTherapistFiltersAction = () => ({ type: RESET_GET_THERAPIST_FILTERS });
